<div class="main">
    <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
      <div class="section">
        <div class="sectionHeader">
            <div class="header">
              <div class="title">
                  <div class="label">
                      {{'DEBIT_NOTES.title' | translate}}
                  </div>
                  <div class="help">
                    <!--  <app-help [helpData]="helpData" ></app-help> -->
                  </div>
                </div>
            </div>
          </div>
  
          <div class="historyMain">
            <div class="filter">
              <div class="container">
                <div class="title">
                  <!-- {{'PAYMENT_ADVICE.historyTitle' | translate}} -->
                </div>
                <div class="search">
                    <!-- <div class="inputSearch">
                        <input (keyup)="applyFilter($event.target.value)" placeholder=""  class="inputSelect">
                    </div> -->
                </div>
                <div class="select-date">
                    <div class="title">
                            {{'DEBIT_NOTES.from' | translate}}
                    </div>
                    <div >
                        <input type="text" class="dateSelect" [matDatepicker]="from_date"  [(ngModel)]="date_filter.from_date" [max]="date_filter.max" (click)="from_date.open()"/>
                        <mat-datepicker #from_date (closed)="setFromDateTime(date_filter)" [startAt]="date_filter.from_date"></mat-datepicker>
                        <i class="material-icons calendar">date_range</i>
                    </div>
                </div>
  
                <div class="select-date">
                    <div class="title">
                            {{'DEBIT_NOTES.to' | translate}}
                    </div>
                    <div >
                        <input type="text" class="dateSelect" [matDatepicker]="to_date" [(ngModel)]="date_filter.to_date" [min]="date_filter.min" (click)="to_date.open()"/>
                        <i class="material-icons icon calendar">date_range</i>
                        <mat-datepicker #to_date (closed)="setToDateTime(date_filter)" [startAt]="date_filter.to_date" ></mat-datepicker>
                    </div>
                </div>
           </div>
          </div>
          </div>
            <div class="tableMain">
              <div class="table" >
                <table mat-table class="mat-elevation-z2" #table [dataSource]="debitNotesList.filteredData" *ngIf="debitNotesList && debitNotesList.filteredData.length;else noAdvice ">
                        <ng-container matColumnDef="credit_note_no">
                            <th mat-header-cell *matHeaderCellDef class="customHeader">
                                {{'DEBIT_NOTES.credit_note_no' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="billSection">
                                <a href="{{element.pdf_link}}">{{element.CNIN}}</a>
                            </td>
                        </ng-container>
  
                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef class="customHeader">
                                {{'DEBIT_NOTES.amount' | translate}} ({{symbol}})
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.amount}}</td>
                        </ng-container>
  
                        <ng-container matColumnDef="tax_amount">
                            <th mat-header-cell *matHeaderCellDef class="customHeader">
                                {{'DEBIT_NOTES.tax_amount' | translate}} ({{symbol}})
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.tax_amount}}</td>
                        </ng-container>
  
                        <ng-container matColumnDef="final_amount">
                            <th mat-header-cell *matHeaderCellDef class="customHeader">
                                {{'DEBIT_NOTES.total' | translate}} ({{symbol}})
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.final_amount}}</td>
                        </ng-container>
  
                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="row.expand = !row.expand" ></tr>
                    </table>
                    <mat-paginator [length]="(debitNotesList)? totalAdvices:0" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons
                        (page)="pageNavigate($event)" style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>
              </div>
              <ng-template #noAdvice>
                <div class="noAdvice">
                        {{'DEBIT_NOTES.no_credit_notes_found' | translate}}
                </div>
              </ng-template>
          </div>
        </div>
    </div>
  